import axios from "axios";
import { API_URL } from "@/config";
import { Toast } from "vant";
import MD5 from "crypto-js/md5";

// import store from "/src/store";

const transformObjToSearchParams = (obj = {}) => {
  const params = new URLSearchParams()
  const keys = Object.keys(obj).sort()
  keys.forEach(key => params.append(key, obj[key]))
  return params.toString() + 'boxhtfbk'
}

const md5Str = (str) => {
  return MD5(str).toString().toLowerCase()
}

class HttpRequest {
  getInsideConfig() {
    const config = {
      baseURL: API_URL,
      headers: {},
      method: "post", //  默认请求方式为post,其他方式需调request时另写
      timeout: 20 * 1000
    };
    return config;
  }
  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        // if (config.requireToken) {
        //   const token = localStorage.getItem("token") || "";
        //   config.headers.token = token;
        //   config.headers.Authorization = token;
        // }
        if (config.useTemp) {
          const tempId = localStorage.getItem("tempId") || 0;
          config.headers["template-id"] = tempId;
        }
        // 统一处理 sign
        if (config.requireSign !== false) {
          if (!config.data.sign) {
            // TODO DELETE
            config.data.source_sign = transformObjToSearchParams(config.data)
            config.data.sign = md5Str(config.data.source_sign)
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        const { data, status, config } = res;
        if (status === 200) {
          if (data.ret === 1 || data.code === 0) {
            return data;
          } else {
            if ((data.msg || data.message) && !config.unHint && !config.judgeCode) {
              Toast.fail({
                message: data.msg || data.message,
                duration: 2000,
              });
            }
            return Promise.reject(data);
          }
        }
      },
      (error) => {
        let errorInfo = error.response;
        if (error.response.status === 404 && error.config.requireToken) {
          Toast.fail({
            message: "系统繁忙，请稍后再试~",
            duration: 2000,
          });
        }
        if (error.response.status === 401 && error.config.requireToken) {
          // store.dispatch('globalInfo/changeLoginStatus',{ isLogin: false });
          // store.dispatch('globalInfo/updateUserToken',{ token: '', info: {} });
        }
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config,
          } = JSON.parse(JSON.stringify(error));
          errorInfo = {
            statusText,
            status,
            request: {
              responseURL: config.url,
            },
          };
        }
        return Promise.reject(error);
      }
    );
  }
  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    // 本地不同服务对应不同接口
    // if (options.url === '/wx-box-active/vip/activity/list') {
    //   options.baseURL = '//172.16.28.40:10063'
    // }
    // if (options.url === '/wx-box-user/user/check') {
    //   options.baseURL = '//172.16.28.40:10061'
    // }
    this.interceptors(instance);
    return instance(options);
  }
  // 上传图片单独使用
  uploadFile(options) {
    const instance = axios.create({
      headers: {
        "Content-Type": "multipart/form-data",
      },
      baseURL: API_URL,
    });
    this.interceptors(instance);
    return instance(options);
  }
}
export default HttpRequest;
